import { Box, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import { useStore } from '@stores';

interface ILink {
  id: string;
  hideButton?: boolean;
}

export const LinkWithDrawer = observer(({ id, hideButton = false }: ILink) => {
  const { t } = useTranslation('footer');
  const {
    partnerStore: { partner },
    initializeStore,
  } = useStore();

  const openLinkInNewTab = () => {
    const language = initializeStore.options.language;
    const linkUrls: Record<string, string> = {
      termsOfUse:
        language === 'es' ? partner!.terms_url_es! : partner!.terms_url!,
      privacyPolicy:
        language === 'es' ? partner!.privacy_url_es! : partner!.privacy_url!,
      esignDisclosure:
        language === 'es' ? partner!.esign_url_es! : partner!.esign_url!,
    };

    const url = linkUrls[id];
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      {!hideButton && (
        <Button
          onClick={openLinkInNewTab}
          sx={{
            padding: 0,
            fontSize: '12px',
            lineHeight: 1.2,
            fontWeight: 500,
            color: '#4EA0BA',
            textDecoration: 'none',
            backgroundColor: 'transparent',
            letterSpacing: '0.25px',
            '&:hover': {
              backgroundColor: 'transparent',
            },
            textTransform: 'capitalize',
          }}
        >
          {t(id)}
        </Button>
      )}
    </Box>
  );
});
